import QuoteWrapper from './QuoteWrapper';
export default QuoteWrapper;